import { render, staticRenderFns } from "./BpTableResponsive.vue?vue&type=template&id=d5edfaee&scoped=true&"
import script from "./BpTableResponsive.vue?vue&type=script&lang=js&"
export * from "./BpTableResponsive.vue?vue&type=script&lang=js&"
import style0 from "./BpTableResponsive.vue?vue&type=style&index=0&id=d5edfaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5edfaee",
  null
  
)

export default component.exports